<script>
    import { Router, Route } from 'svelte-routing';

    import Footer from '../components/Footer.svelte';

    import ComparatorRes from '../views/comparator/ComparatorRes.svelte';
    import ComparatorNeg from '../views/comparator/ComparatorNeg.svelte';
    import ComparatorSky from '../views/comparator/ComparatorSky.svelte';

    // Store
    import { store, store_offer } from '../Store.svelte';

    export let compara = '';
</script>

<div
    class="comparator"
    class:secondary-font={$store.requestedServices.isSky}
    class:secondary-body-bg={$store.requestedServices.isSky}
>
    <Router url="comparador">
        <Route path="" component={ComparatorRes} />
        <Route path="negocios" component={ComparatorNeg} />
        <Route path="sky" component={ComparatorSky} />
    </Router>
    <Footer />
</div>
